import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { keyDownHandler } from '../shared';
import { SelectionMenuContainer, SelectionMenuItem } from '../styles';

var SelectionMenu = function SelectionMenu(props) {
  var items = props.items,
      activeItemIndex = props.activeItemIndex,
      onItemClick = props.onItemClick,
      _props$menuDirection = props.menuDirection,
      menuDirection = _props$menuDirection === void 0 ? 'horizontal' : _props$menuDirection,
      restProps = _objectWithoutProperties(props, ["items", "activeItemIndex", "onItemClick", "menuDirection"]);

  var itemRefs = [];
  return /*#__PURE__*/React.createElement(SelectionMenuContainer, _extends({}, restProps, {
    role: "radiogroup",
    menuDirection: menuDirection
  }), items.map(function (item, index) {
    itemRefs.push( /*#__PURE__*/React.createRef());
    return /*#__PURE__*/React.createElement(SelectionMenuItem, {
      key: index,
      onClick: function onClick() {
        return onItemClick(index);
      },
      role: "radio",
      "aria-checked": index === activeItemIndex,
      tabIndex: !activeItemIndex && index === 0 || index === activeItemIndex ? 0 : -1,
      onKeyDown: keyDownHandler(itemRefs, activeItemIndex || 0),
      ref: itemRefs[index]
    }, item.icon && /*#__PURE__*/React.cloneElement(item.icon, {
      width: 20,
      height: 20
    }), item.text);
  }));
};

SelectionMenu.displayName = 'SelectionMenu';
export default SelectionMenu;